/**
 * Step validation and parsing utilities
 */
import { INTRO_STEP_ID, REVIEW_STEP_ID, REVIEW_URL_PATH } from './constants';

/**
 * Checks if a step is a special step (intro or review)
 * @param {number|string} stepId - Step ID to check
 * @returns {boolean} True if special step
 */
export const isSpecialStep = (stepId) =>
  Number(stepId) === INTRO_STEP_ID || Number(stepId) === REVIEW_STEP_ID;

/**
 * Checks if a step is the intro step
 * @param {number|string} stepId - Step ID to check
 * @returns {boolean} True if intro step
 */
export const isIntroStep = (stepId) => Number(stepId) === INTRO_STEP_ID;

/**
 * Checks if a step is the review step
 * @param {number|string} stepId - Step ID to check
 * @returns {boolean} True if review step
 */
export const isReviewStep = (stepId) => Number(stepId) === REVIEW_STEP_ID;

/**
 * Converts a URL step_id parameter to the actual step ID
 * Handles special cases: undefined/empty → intro, 'review' → review step
 * @param {string|undefined} urlStepId - Step ID from URL params
 * @returns {number|string} Actual step ID
 */
export const parseUrlStepId = (urlStepId) => {
  if (!urlStepId) return INTRO_STEP_ID;
  if (urlStepId === REVIEW_URL_PATH) return REVIEW_STEP_ID;
  return urlStepId;
};
